export default __webpack_public_path__ + "static/media/1.30877d07.svg";